import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 text-gray-800 dark:bg-black dark:text-white mt-auto">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <div className="flex justify-center mb-6">
            <img 
              src="/logo-light.webp" 
              alt="AllSEO Conferences" 
              className="h-36 w-auto dark:hidden"
              data-testid="footer-logo-light"
            />
            <img 
              src="/logo-dark.webp" 
              alt="AllSEO Conferences" 
              className="h-36 w-auto hidden dark:block"
              data-testid="footer-logo-dark"
            />
          </div>
          <p className="text-gray-600 dark:text-gray-400 text-lg mb-2">
            The premier directory for search marketing professionals.
          </p>
          <p className="text-gray-500">
            Discover, attend, and grow.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-300 dark:border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            © {currentYear} allseoconferences.com. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors text-sm"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors text-sm"
            >
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
